/** Download — single share link for both stores. URL: /descargar (alias /download). */
import { Link } from 'react-router-dom';
import { useWww } from './_layout';
import { wwwTheme, wwwFonts } from '@/src/website/theme';
import { SeoHead } from '@/src/website/SeoHead';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '@/src/website/seo';

export default function Download() {
  const { t, lang } = useWww();
  // Device detection only reorders the buttons — both stores are ALWAYS visible,
  // and there is never an automatic redirect.
  const isAndroid = typeof navigator !== 'undefined' && /android/i.test(navigator.userAgent);

  const appStoreBtn = (
    <a key="ios" data-testid="download-appstore-btn" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
      <img src={`/badges/appstore-${lang}.svg`} alt={t.downloadAppStoreAlt} style={{ height: 56, display: 'block' }} />
    </a>
  );
  const playBtn = (
    <a key="android" data-testid="download-googleplay-btn" href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" style={{ display: 'block' }}>
      <img src={`/badges/play-${lang}.png`} alt={t.downloadGooglePlayAlt} style={{ height: 56, display: 'block' }} />
    </a>
  );
  const buttons = isAndroid ? [playBtn, appStoreBtn] : [appStoreBtn, playBtn];

  return (
    <>
      <SeoHead page="download" locale={lang} />
      <div data-testid="download-page" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', paddingLeft: 24, paddingRight: 24, paddingTop: 72, paddingBottom: 96, maxWidth: 560, width: '100%', marginLeft: 'auto', marginRight: 'auto', boxSizing: 'border-box' }}>
        <img src="/logo-mark.png" alt="STILGIA" data-testid="download-logo" style={{ width: 72, height: 72, display: 'block' }} />
        <h1 data-testid="download-claim" style={{ color: wwwTheme.text, fontFamily: wwwFonts.serifBold, fontSize: 38, lineHeight: '44px', marginTop: 26, marginBottom: 0 }}>{t.downloadClaim}</h1>
        <p data-testid="download-sub" style={{ color: wwwTheme.muted, fontSize: 16, lineHeight: '24px', marginTop: 14, marginBottom: 0, maxWidth: 420 }}>{t.downloadSub}</p>
        <div data-testid="download-buttons" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18, marginTop: 40 }}>{buttons}</div>
        <Link to="/home" data-testid="download-home-link" style={{ marginTop: 44, textDecoration: 'none' }}>
          <span style={{ color: wwwTheme.muted, fontSize: 14, borderBottom: `1px solid ${wwwTheme.border}`, paddingBottom: 2 }}>{t.downloadHomeLink}</span>
        </Link>
      </div>
    </>
  );
}
